function updateCartCookie() {
  fetch("/cart.json").then((data) => {
    data.json().then((cart) => {
      const totalItems = cart.item_count.toString();
      const totalPrice = cart.total_price.toString();

      let products = [];
      let cartProducts = cart.items;
      cartProducts.forEach((product) => {
        let item = {
          title: product.title,
          price: product.price,
          image: product.featured_image.url,
        };
        products.push(item);
      });

      const cartInfo = {
        totalItems: totalItems,
        totalPrice: totalPrice,
        products: products,
        domain: location.origin,
        currency: cart.currency,
      };
      //console.log(cartInfo);
      document.cookie = `cartinfo=${JSON.stringify(
        cartInfo
      )}; path=/; max-age=${60 * 60 * 24 * 30};`;
    });
  });
}
/*
   event fires after cart changes. 
  */
document.addEventListener("theme:loading:end", () => {
  updateCartCookie();
});
/* update on initial load */
document.addEventListener("DOMContentLoaded", () => {
  updateCartCookie();
});
